<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-row class="mt-5">
            <v-col cols="12" lg="8" offset-lg="2">
                <v-btn
                    color="error"
                    text
                    href="/admin/stores"
                >Atrás</v-btn>
                <v-card class="mb-5">
                    <v-card-text>
                        <v-form @submit.prevent="formAdd" ref="refadd" lazy-validation>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <h4>Datos de cuenta</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <!-- name -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Nombre completo"
                                        type="text"
                                        name="name"
                                        outlined
                                        dense
                                        v-model="data.name"
                                        :rules="[rules.required]"
                                        :error="errors['name'] ? true :false"
                                        :error-messages="errors['name'] ? errors['name'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <!-- end name -->
                                <!-- email -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Correo electrónico"
                                        type="email"
                                        name="email"
                                        outlined
                                        dense
                                        v-model="data.email"
                                        :rules="[rules.required, rules.email]"
                                        :error="errors['email'] ? true :false"
                                        :error-messages="errors['email'] ? errors['email'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <!-- end email -->
                                <!-- phone -->
                                <v-col cols="12" md="6" class="px-2">
                                    <vue-tel-input-vuetify
                                        label="Tel/cel *"
                                        outlined
                                        dense
                                        :onlyCountries="['bo', 'us', 'es', 'ar', 'cl', 'co', 'ec', 'mx', 'pe', 've', 'br']"
                                        :default-country="defaultCountry"
                                        :rules="[rules.required]"
                                        :value="data.tmpPhone"
                                        @input="onInput"
                                        :error="errors['phone'] ? true :false"
                                        :error-messages="errors['phone'] ? errors['phone'][0] : ''"
                                    ></vue-tel-input-vuetify>
                                </v-col>
                                <!-- end phone -->
                                <!-- country -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-select
                                        :items="itemsCountry"
                                        item-value="val"
                                        item-text="text"
                                        label="País *"
                                        outlined
                                        dense
                                        v-model="data.country"
                                        :rules="[rules.required]"
                                        :error="errors['country'] ? true :false"
                                        :error-messages="errors['country'] ? errors['country'][0] : ''"
                                    ></v-select>
                                </v-col>
                                <!-- end country -->
                                <!-- address -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Dirección"
                                        type="text"
                                        name="address"
                                        outlined
                                        dense
                                        v-model="data.address"
                                        :rules="[rules.required]"
                                        :error="errors['address'] ? true :false"
                                        :error-messages="errors['address'] ? errors['address'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <!-- end address -->
                                <!-- password -->
                                <v-col cols="12" md="6" class="px-2">
                                    <div class="input-container d-flex">
                                        <v-text-field
                                            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="show1 ? 'text' : 'password'"
                                            label="Contraseña *"
                                            hint="Mínimo 8 caracteres"
                                            counter
                                            dense
                                            outlined
                                            v-model="data.password"
                                            :rules="[rules.required, rules.min]"
                                            :error="errors.password ?true :false"
                                            :error-messages="errors['password'] ? errors['password'][0] : ''"
                                            @click:append="show1 = !show1"
                                        ></v-text-field>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    class="ml-2"
                                                    fab
                                                    dark
                                                    small
                                                    color="primary"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="data.password = genRandom()"
                                                >
                                                    <v-icon dark>
                                                        mdi-reload
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Generar</span>
                                        </v-tooltip>
                                    </div>
                                </v-col>
                                <!-- end password -->

                                <v-col cols="12">
                                    <h4>Datos del negocio</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <!-- name -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Nombre del negocio"
                                        type="text"
                                        name="name_store"
                                        outlined
                                        dense
                                        v-model="data.nameStore"
                                        :rules="[rules.required]"
                                        :error="errors['name_store'] ? true :false"
                                        :error-messages="errors['name_store'] ? errors['name_store'][0] : ''"
                                        @blur="generateSlug"
                                    ></v-text-field>
                                </v-col>
                                <!-- end name -->
                                <!-- slug -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Slug"
                                        type="text"
                                        name="slug"
                                        outlined
                                        dense
                                        v-model="data.slug"
                                        :rules="[rules.required]"
                                        :error="errors['slug'] ? true :false"
                                        :error-messages="errors['slug'] ? errors['slug'][0] : ''"
                                    >
                                        <template v-slot:prepend>
                                            <div class="text--disabled pt-1" style="width:170px">
                                                {{ tmpSlug }}
                                            </div>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <!-- end slug -->
                                 <!-- type -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-select
                                        :items="itemsTypeStores"
                                        item-value="id"
                                        item-text="name"
                                        label="Tipo de tienda *"
                                        outlined
                                        dense
                                        v-model="data.typeStoreId"
                                        :rules="[rules.required]"
                                        :error="errors['type_store_id'] ? true :false"
                                        :error-messages="errors['type_store_id'] ? errors['type_store_id'][0] : ''"
                                    ></v-select>
                                </v-col>
                                <!-- end type -->
                                 <!-- language -->
                                <v-col cols="12" md="6" class="px-2">
                                    <v-select
                                        :items="itemsLanguages"
                                        item-value="val"
                                        item-text="text"
                                        label="Idioma principal *"
                                        outlined
                                        dense
                                        v-model="data.locale"
                                        :rules="[rules.required]"
                                        :error="errors['locale'] ? true :false"
                                        :error-messages="errors['locale'] ? errors['locale'][0] : ''"
                                    ></v-select>
                                </v-col>
                                <!-- end language -->

                                <v-col cols="12">
                                    <h4>Puntos de venta</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Cantidad de puntos de venta"
                                        type="number"
                                        outlined
                                        dense
                                        v-model="data.pointSale"
                                        :error="errors['point_sale'] ? true :false"
                                        :error-messages="errors['point_sale'] ? errors['point_sale'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <!-- end points -->

                                <v-col cols="12">
                                    <h4>Preventista</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Cantidad de preventista"
                                        type="number"
                                        outlined
                                        dense
                                        v-model="data.preventist"
                                        :error="errors['preventist'] ? true :false"
                                        :error-messages="errors['preventist'] ? errors['preventist'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <!-- end points -->

                                 <!-- qr code -->
                                <template v-if="data.typeStoreId === 3">
                                    <v-col cols="12">
                                        <h4>Cantidad de codigos QR</h4>
                                        <v-divider class="mb-4"></v-divider>
                                    </v-col>
                                    <v-col cols="12" md="6" class="px-2">
                                        <v-text-field
                                            placeholder="Cantidad de codigos QR"
                                            type="number"
                                            outlined
                                            dense
                                            v-model="data.cant_qr"

                                        ></v-text-field>
                                    </v-col>
                                </template>

                                <template v-if="data.typeStoreId === 3">
                                    <v-col cols="12">
                                        <h4>Número de pantallas permitidas</h4>
                                        <v-divider class="mb-4"></v-divider>
                                    </v-col>
                                    <v-col cols="12" md="6" class="px-2">
                                        <v-text-field
                                            placeholder="Número de pantallas permitidas"
                                            type="number"
                                            min="0"
                                            outlined
                                            dense
                                            v-model="data.allowed_screens"
                                        ></v-text-field>
                                    </v-col>
                                </template>

                                <v-col cols="12">
                                    <h4>Tamaño de impresión del recibo</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-radio-group
                                        v-model="data.sizePrint"
                                        row
                                        class="mt-0"
                                    >
                                        <v-radio
                                            label="Papel carta"
                                            value="md"
                                        ></v-radio>
                                        <v-radio
                                            label="Papel térmico"
                                            value="sm"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-col>

                                <!-- retorno inversion -->
                                <v-col cols="12" class="px-2">
                                    <h4>Datos de inversión</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Inversión meses"
                                        type="number"
                                        outlined
                                        dense
                                        v-model="data.investmentMounths"
                                        :error="errors['investment_mounths'] ? true :false"
                                        :error-messages="errors['investment_mounths'] ? errors['investment_mounths'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Inversión Bs."
                                        type="number"
                                        outlined
                                        dense
                                        v-model="data.investmentAmount"
                                        :error="errors['investment_amount'] ? true :false"
                                        :error-messages="errors['investment_amount'] ? errors['investment_amount'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="rentabilidad en %"
                                        type="number"
                                        outlined
                                        dense
                                        v-model="data.profitabilityIn"
                                        :error="errors['profitability_in'] ? true :false"
                                        :error-messages="errors['profitability_in'] ? errors['profitability_in'][0] : ''"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-menu
                                        v-model="menuD"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="data.investmentInit"
                                                label="Fecha inicial"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                outlined
                                                dense
                                                color="orange"
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="data.investmentInit"
                                            @input="menuD = false"
                                            locale="es"
                                            color="primary"
                                            class="ma-0"
                                            type="month"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <!-- END inversion -->

                                <v-col cols="12">
                                    <h4>Sucursales</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Cantidad de sucursales"
                                        type="number"
                                        outlined
                                        dense
                                        min="0"
                                        step="1"
                                        v-model="data.branches"
                                        :rules="[rules.numPositive]"
                                    ></v-text-field>
                                </v-col>

                                <!-- datos de mete -->
                                <v-col cols="12">
                                    <h4>Datos de WhatsApp (META)</h4>
                                    <v-divider class="mb-4"></v-divider>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="ID whatsapp"
                                        outlined
                                        dense
                                        v-model="data.metaIdPhone"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6" class="px-2">
                                    <v-text-field
                                        placeholder="Token de acceso"
                                        outlined
                                        dense
                                        v-model="data.metaToken"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" class="px-2">
                                    <h4>Otros</h4>
                                    <v-divider class="mb-4"></v-divider>
                                    <v-checkbox
                                        v-model="data.inventory"
                                        label="Inventario"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.physicalStore"
                                        label="Tienda fisica"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.preventistChange"
                                        label="Preventista cambio de precios"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.restaurant"
                                        label="Restaurante físico"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.fidelityPoints"
                                        label="Puntos de fidelidad"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.isDomain"
                                        label="Dominio propio"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.openProductNewTab"
                                        label="Abrir productos en ventana nueva"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.hasMarketing"
                                        label="Asistente IA + envío masivo"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.hasQuotes"
                                        label="Cotizaciones"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>
                                    <v-checkbox
                                        v-model="data.categories3Levels"
                                        label="Categoría 3 niveles"
                                        :false-value="false"
                                        :true-value="true"
                                        hide-details
                                    ></v-checkbox>

                                    <p class="mb-3">&nbsp;</p>
                                </v-col>

                                <v-col cols="12" sm="12" class="text-center">
                                    <v-btn
                                        type="submit"
                                        dark
                                        color="primary"
                                        :loading="loading"
                                    >
                                        Guardar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';
export default {
    components: {
        VueTelInputVuetify,
    },
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Negocios',
                    disabled: false,
                    href: '/admin/stores',
                },
                {
                    text: 'Nuevo',
                    disabled: true,
                    href: '',
                }
            ],
            show1: true,
            itemsCountry: [
                {val: 'bo', text: 'Bolivia'},
                {val: 'us', text: 'Estados Unidos'},
                {val: 'es', text: 'España'},
                {val: 'ar', text: 'Argentina'},
                {val: 'cl', text: 'Chile'},
                {val: 'co', text: 'Colombia'},
                {val: 'ec', text: 'Ecuador'},
                {val: 'mx', text: 'México'},
                {val: 'pe', text: 'Perú'},
                {val: 've', text: 'Venezuela'},
                {val: 'br', text: 'Brasil'},
            ],
            itemsTypeStores: [],
            defaultCountry: '',
            itemsLanguages: [
                {val: 'es', text: 'Español'},
                {val: 'en', text: 'Inglés'},
                {val: 'pt', text: 'Português'},
            ],
            data: {
                name: '',
                email: '',
                tmpPhone: '',
                phoneCode: '',
                phoneIso: '',
                phoneValid: false,
                phone: '',
                address: '',
                password: '',
                nameStore: '',
                slug: '',
                typeStoreId: '',
                pointSale: 0,
                preventist: 0,
                cant_qr: 0,
                allowed_screens: 0,
                sizePrint: 'sm',
                country: '',
                inventory: false,
                physicalStore: false,
                investmentMounths: '',
                investmentAmount: '',
                profitabilityIn: '',
                investmentInit: '',
                preventistChange: false,
                restaurant: false,
                fidelityPoints: false,
                isDomain: false,
                branches: 0,
                openProductNewTab: false,
                hasMarketing: false,
                locale: '',
                metaIdPhone: '',
                metaToken: '',
                hasQuotes: false,
                categories3Levels: false,
            },
            menuD: false,
            tmpSlug: 'http://'+window.location.hostname+'/',
            // validation
            rules: {
                required: v => !!v || 'El campo es requerido',
                min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido',
                numPositive: v => v >= 0 || 'Debe ser un número positivo',
            },
            errors: {},
        }
    },
    created() {
        this.data.password = this.genRandom()
    },
    mounted() {
        this.getTypeStores()
    },
    methods: {
        onInput(formattedNumber, { number, valid, country }) {
            this.data.phoneCode = '+'+country.dialCode
            this.data.phone = number.significant
            this.data.tmpPhone = number.international
            this.data.phoneIso = country.iso2
            this.data.phoneValid = valid

            this.data.country = country.iso2.toLowerCase()
        },
        /**
         * type stores
         */
        async getTypeStores() {
            await axios.get('/admin/list-types-stores')
            .then(response => {
                // console.log(response);
                this.itemsTypeStores = response.data
            })
            .catch(error => {
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        /**
         * register
         */
        genRandom () {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < 10; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result
            // this.data.password = result
        },
        async generateSlug(e) {
            var tmpSlug = (e.target.value).replace(/\s+/g, '-').toLowerCase()
            await axios.post('/admin/verify-slug', {tmpslug: tmpSlug})
            .then((response) => {
                // console.log(response)
                this.data.slug = response.data
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        async formAdd() {
            if (this.$refs.refadd.validate()) {
                
                // validación de número de celular para Bolivia
                if (this.data.phoneIso == 'BO') {
                    const digits = (this.data.phone || '').replace(/\D/g, '');
                    this.data.phoneValid = /^[567]\d{7}$/.test(digits); // 8 dígitos, empieza con 5, 6 o 7
                }

                // validación de número de celular para otros países
                if (!this.data.phoneValid) {
                    this.$alert('', 'Número de celular incorrecto.', 'error', {confirmButtonText: 'Continuar'})
                    return
                }
                
                this.errors = {}
                this.loading = true
                const formData = new FormData
                formData.append('name', this.data.name)
                formData.append('email', this.data.email)
                formData.append('phone', this.data.phone)
                formData.append('code', this.data.phoneCode)
                formData.append('iso2', this.data.phoneIso)
                formData.append('address', this.data.address)
                formData.append('password', this.data.password)
                formData.append('name_store', this.data.nameStore)
                formData.append('slug', this.data.slug)
                formData.append('type_store_id', this.data.typeStoreId)
                formData.append('point_sale', this.data.pointSale)
                formData.append('preventist', this.data.preventist)
                formData.append('cant_qr', this.data.cant_qr)
                formData.append('allowed_screens', this.data.allowed_screens)
                formData.append('size_print', this.data.sizePrint)
                formData.append('country', this.data.country)
                formData.append('inventory', this.data.inventory?1:0)
                formData.append('physical_store', this.data.physicalStore?1:0)
                formData.append('investment_mounths', this.data.investmentMounths)
                formData.append('investment_amount', this.data.investmentAmount)
                formData.append('profitability_in', this.data.profitabilityIn)
                formData.append('investment_init', this.data.investmentInit)
                formData.append('change_price_preventist', this.data.preventistChange?1:0)
                formData.append('fidelity_points', this.data.fidelityPoints?1:0)
                formData.append('is_domain', this.data.isDomain?1:0)
                formData.append('restaurant', this.data.restaurant?1:0)
                formData.append('branches', this.data.branches)
                formData.append('open_product_new_tab', this.data.openProductNewTab?1:0)
                formData.append('hasMarketing', this.data.hasMarketing?1:0)
                formData.append('locale', this.data.locale)
                formData.append('meta_idphone', this.data.metaIdPhone)
                formData.append('meta_token', this.data.metaToken)
                formData.append('has_quotes', this.data.hasQuotes?1:0)
                formData.append('categories_3_levels', this.data.categories3Levels?1:0)

                await axios.post('/admin/new-store', formData)
                .then((response) => {
                    // console.log(response);
                    if (response.data == 'ok') {
                        this.$alert('', 'Registro con éxito.', 'success', {confirmButtonText: 'Continuar'})
                        this.data.name = ''
                        this.data.email = ''
                        this.data.tmpPhone = ''
                        this.data.phoneCode = ''
                        this.data.phoneIso = ''
                        this.data.phoneValid = false
                        this.data.phone = ''
                        this.data.address = ''
                        this.data.password = ''
                        this.data.nameStore = ''
                        this.data.country = ''
                        this.data.slug = ''
                        this.data.typeStoreId = ''
                        this.data.pointSale = 0
                        this.data.preventist = 0
                        this.data.cant_qr = 0
                        this.data.allowed_screens = 0
                        this.data.investmentMounths = ''
                        this.data.investmentAmount = ''
                        this.data.profitabilityIn = ''
                        this.data.investmentInit = ''
                        this.data.preventistChange = false
                        this.data.fidelityPoints = false
                        this.data.isDomain = false
                        this.data.restaurant = false
                        this.data.branches = null
                        this.data.hasMarketing = false
                        this.data.metaIdPhone = ''
                        this.data.metaToken = ''
                        this.data.hasQuotes = false
                        this.data.categories3Levels = false
                        this.$refs.refadd.resetValidation()
                    }
                    this.loading = false
                })
                .catch((error) => {
                    // console.log(error);
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                })
            }
        }
    },
}
</script>
